import React, { useEffect, useState } from 'react';
import { Col, Row, Form, FloatingLabel } from 'react-bootstrap';
import { fetchHVAScorecardNames } from 'services/hvaqa.service';
import QAScorecard from '../../components/modules/dashboard/QADashboardScorecard';
import HVASpinner from 'components/base/HVASpinner';

interface Scorecard {
  id: number;
  name: string;
  active: boolean;
}

const QADashboard = () => {
  const [scorecards, setScorecards] = useState<Scorecard[]>([]);
  // eslint-disable-next-line
  const [selectedScorecard, setSelectedScorecard] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Cargar los Scorecards
  useEffect(() => {
    const loadScorecards = async () => {
      setIsLoading(true); // Inicia el loader
      try {
        const scorecardNames = await fetchHVAScorecardNames();
        if (Array.isArray(scorecardNames)) {
          setScorecards(scorecardNames);
        } else {
          throw new Error('Invalid response format');
        }
      } catch (error) {
        if (error instanceof Error) {
          setError('Error loading Scorecards: ' + error.message);
        } else {
          setError('Unknown error occurred while loading Scorecards');
        }
      } finally {
        setIsLoading(false); // Detiene el loader
      }
    };

    loadScorecards();
  }, []);

  // Controlador para manejar la selección de Scorecard
  const handleScorecardChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedScorecard(e.target.value);
  };

  return (
    <>
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-0 pb-0 mb-0">
        <Row className="gy-3 mb-1 justify-content-between">
          <Col>
            <h2 className="mb-2 text-body-emphasis">Scorecard Dashboard</h2>
            <h5 className="text-body-tertiary fw-semibold">
              Start by selecting a scorecard
            </h5>
          </Col>
          <Col>
            <div className="d-flex w-100 align-items-center">
              <FloatingLabel
                controlId="scorecards"
                label="Scorecard selection"
                className="w-100"
              >
                {isLoading ? (
                  <HVASpinner />
                ) : (
                  <Form.Select
                    id="scorecard"
                    value={selectedScorecard ?? ''}
                    onChange={handleScorecardChange}
                  >
                    <option value="">Select a scorecard</option>
                    {scorecards.map(scorecard => (
                      <option
                        key={scorecard.id}
                        value={scorecard.id.toString()}
                      >
                        {scorecard.name} {!scorecard.active ? '(Inactive)' : ''}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </FloatingLabel>
            </div>
          </Col>
        </Row>

        {/* Mostrar un mensaje de error si hay problemas al cargar los scorecards */}
        {error && <div className="text-danger mt-3">{error}</div>}
      </div>
      <div id="Content" className="mx-n4 px-4 mx-lg-n6 px-lg-6">
        {/* Llamamos a un componente o mostramos más información sobre el scorecard seleccionado */}
        {selectedScorecard ? (
          <QAScorecard scorecardid={Number(selectedScorecard)} />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default QADashboard;
